/* __next_internal_client_entry_do_not_use__ DrawerAmount auto */ import { jsx as _jsx } from "react/jsx-runtime";
import { DrawerTips } from "./DrawerTips";
const DrawerAmount = (param)=>{
    let { open, onClose, amount = 0 } = param;
    const t = useTranslations();
    const title = useMemo(()=>t("pledgeAmount"), [
        t
    ]);
    return /*#__PURE__*/ _jsx(DrawerTips, {
        open: open,
        onClose: onClose,
        title: title,
        content: t("bgbStakingCreditAmountDescription", {
            amount
        })
    });
};
export { DrawerAmount };
